import { ParentOrganizationInfo } from "services/organization";
import { Label } from "@wexinc/wex-ui";
import React from "react";
import { Link } from "react-router-dom";

interface Props {
  parentInfo?: ParentOrganizationInfo;
}

const OrganizationBreadcrumb: React.FC<Props> = (props) => {
  const lineage = getLineage(props);
  return (
    <ul>
      {lineage.map((i, index) => {
        const isLast = index === lineage.length - 1;

        return (
          <React.Fragment key={i.url}>
            <Link
              to={i.url}
              className="text-sm text-primary-40"
              data-test-id={i.testId}
            >
              {i.label}
            </Link>
            {!isLast && <Label className="px-1">&#62;</Label>}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default OrganizationBreadcrumb;

interface BreadcrumbData {
  label: string;
  url: string;
  testId: string;
}

function getLineage(props: Props) {
  const bottomToTopOrganizations: BreadcrumbData[] = [];
  let parentInfo = props.parentInfo;
  while (parentInfo) {
    bottomToTopOrganizations.push({
      label: parentInfo.name,
      url: parentInfo.id,
      testId: `organization-${parentInfo.id}`,
    });
    parentInfo = parentInfo.parent;
  }

  bottomToTopOrganizations.push({
    label: "All organizations",
    url: "",
    testId: "organization-root",
  });

  bottomToTopOrganizations.reverse();

  return bottomToTopOrganizations;
}
